export enum HtmlNode {
    Block = 'html_block',
    Inline = 'html_inline',
}

export enum HtmlAttr {
    Content = 'html-content',
}
